import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar'; // Ensure this path is correct based on your project structure
import AboutTureMedicine from '../components/AboutTureMedicine';
import founderImage from "./founder.jpg"; // Ensure this path is correct
import Footer from '../components/Footer'; // Corrected import path
import "./About.css"; // Optional: For styling, create a CSS file if needed.

const About = () => {
  const navigate = useNavigate();

  // Update the page title
  useEffect(() => {
    document.title = "About - TureMedicine";
  }, []);

  return (
    <>
      <Navbar /> {/* Navbar added here */}
      
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <h1>About TureMedicine</h1>
          <p>Your trusted partner in telehealthcare across India.</p>
          <button className="hero-btn">Get Started</button>
        </div>
      </div>

      <div className="about-page">
        <div className="about-content">
          <section className="about-mission">
            <h2>Our Mission</h2>
            <p>
              At TureMedicine, our mission is to make quality healthcare accessible to everyone, 
              regardless of location. We aim to bridge the gap between patients and healthcare 
              professionals through innovative technology and a user-friendly platform.
            </p>
          </section>
          <section className="about-services">
            <h2>What We Offer</h2>
            <ul>
              <li>Search for doctors across all cities in India.</li>
              <li>Book video consultations with ease.</li>
              <li>Access personalized healthcare services and history.</li>
              <li>Empower doctors with efficient profile and appointment management tools.</li>
            </ul>
          </section>
          <AboutTureMedicine />
          <section className="about-vision">
            <h2>Our Vision</h2>
            <p>
              We envision a future where healthcare is not a privilege but a right for everyone. 
              By leveraging technology, we strive to make healthcare services seamless, inclusive, 
              and efficient for all stakeholders.
            </p>
          </section>
          <section className="about-team">
            <h2>Our Team</h2>
            <p>
              TureMedicine is built by a passionate team of healthcare professionals, engineers, 
              and innovators dedicated to improving the healthcare ecosystem in India.
            </p>
          </section>
          <section className="about-developer">
            <h2>Meet the Developer & Founder</h2>
            <div className="developer-profile">
              <img 
                src={founderImage} 
                alt="Shivendra Jha - Founder & CEO" 
                className="developer-image" 
              />
              <div className="developer-details">
                <h3>Shivendra Jha</h3>
                <p>
                  Shivendra Jha is the visionary founder and CEO of TureMedicine. With a deep 
                  passion for technology and healthcare, he has dedicated himself to building 
                  a platform that transforms healthcare accessibility across India. Combining 
                  innovation with compassion, Shivendra leads the TureMedicine team towards a 
                  healthier and more connected world.
                </p>
                <button
                  className="more-about-button"
                  onClick={() => navigate('/shivendra-jha')}
                >
                  More About Shivendra Jha
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer /> {/* Footer will be shown on every page */}
    </>
  );
};

export default About;
